export default class StoreItem {
    constructor(object) {
        this.registered = [];
        this.data = {};
        for (var i in object) this[i] = object[i];
    }
    
    get (property) {
        return (property ? this.data[property] : this.data);
    }
        
    set(properties) {
        for (var i in properties) this.data[i] = properties[i];
        this.emitUpdate();
    }
    
    emitUpdate() {
        this.registered.map((handler) => handler());
    }
        
    onUpdate(handler) {
        this.registered.push(handler);
    }
}